import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsFillTrashFill } from "react-icons/bs";
import { FaSpinner } from "react-icons/fa";

import CartContext from "../../context/CartContext";
import AuthContext from "../../context/authContext";
import "./cartpage.css";

// Formatar URL da imagem
const formatImageUrl = (url) => url.replace("/media/", "/api/media/");

// Formatar preço
const formatPrice = (price) => {
  return Number(price || 0).toLocaleString("pt-AO", {
    style: "currency",
    currency: "AOA",
    minimumFractionDigits: 2,
  });
};
function calcularDesconto25(preco) {
  const desconto = preco * 0.25;
  return desconto;
}

const CartPage = () => {
  const {
    cart,
    removeFromCart,
    increaseQuantity,
    decreaseQuantity,
    adicionar25Porcento,  // <-- Puxando a função do contexto
  } = useContext(CartContext);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  // Calcular total considerando a quantidade e adicionando 25%
  const totalPrice = cart.reduce((acc, item) => {
    const qty = item.quantity || 1;
    // Aplica 25% no preço unitário
    const precoComAcréscimo = (Number(item.preco_com_iva || 0));
    return acc + precoComAcréscimo * qty;
  }, 0);

  const handleCheckout = () => {
    if (user) {
      navigate("/checkout");
    } else {
      alert("Para finalizar é necessário estar com a sessão iniciada.");
      navigate("/loginpage");
    }
  };

  return (
    <div style={{ marginTop: "40px" }}>
      <div className="container mt-4">
        <h2 className="text-center mb-4">🛒 Meu Carrinho</h2>

        {isLoading ? (
          <div className="loading-container">
            <FaSpinner className="spinner" size={30} />
          </div>
        ) : cart.length === 0 ? (
          <div className="text-center">
            <h5>Seu carrinho está vazio.</h5>
            <Link to="/" className="btn btn-primary mt-3">Continuar Comprando</Link>
          </div>
        ) : (
          <div className="card p-3 shadow">
            {cart.map((product) => {
              const precoUnitarioComAcrescimo = adicionar25Porcento(Number(product.preco_com_iva || 0));
              return (
                <div key={product.id} className="d-flex justify-content-between align-items-center border-bottom py-2">
                  <div className="d-flex align-items-center">
                    <img
                      src={formatImageUrl(product.imagem)}
                      alt={product.descricao}
                      className="cart-img me-3"
                    />
                    <div>
                      <h5>{product.descricao}</h5>
                      <p>Preço unitário: {formatPrice(Number(product.preco_com_iva)+calcularDesconto25(product.preco_com_iva))}</p>
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-outline-secondary btn-sm me-2"
                          onClick={() => decreaseQuantity(product.id)}
                        >−</button>
                        <span>{product.quantity || 1}</span>
                        <button
                          className="btn btn-outline-secondary btn-sm ms-2"
                          onClick={() => increaseQuantity(product.id)}
                        >+</button>
                      </div>
                    </div>
                  </div>

                  <button className="btn btn-danger" onClick={() => removeFromCart(product.id)}>
                    <BsFillTrashFill size={20} />
                  </button>
                </div>
              );
            })}

            {/* Total */}
            <div className="mt-3">
              <h4 className="text-end">Total: {formatPrice(totalPrice+calcularDesconto25(totalPrice))}</h4>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <Link to="/" className="btn btn-secondary">
                  Continuar a Comprar
                </Link>
                <button className="btn btn-success" onClick={handleCheckout}>
                  Finalizar Compra
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartPage;
